import React from 'react';
import {Link} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import * as CurrencyFormat from 'react-currency-format';
import _adviserPortalHome from './_adviserPortalHome';

function TotalFum(props){
    const {t} = props;
    const totalFumDetails = _adviserPortalHome._totalFumInDetail(props)
    
    return(
        <div>
        <div><Link className="adviserLoginLink link" to="/adv/totalMembers">
            <div className="adviserDataTotal"><CurrencyFormat  value={Number(totalFumDetails.totalFum).toFixed(2)} 
                            displayType={'text'} 
                            thousandSeparator={true} 
                            prefix={'$'}/></div>
            {t('FUM: totalFum')} 
        </Link></div>

        {
            totalFumDetails.productFum.map((fum, index) => 
            <div key={index}><Link className="adviserLoginDataLink link" to={`/adv/totalMembers/${fum.code}`}>
            <div className="adviserDataSplit"><CurrencyFormat  value={Number(fum.fum).toFixed(2)} 
                            displayType={'text'} 
                            thousandSeparator={true} 
                            prefix={'$'}/></div>
            {fum.name}</Link></div>
            )
        }
        
        {/* <div><Link className="adviserLoginDataLink link" to="/adv/totalMembers/SLKS">
            <div className="adviserDataSplit"><CurrencyFormat  value={Number(totalFumDetails.kiwiSaver).toFixed(2)} 
                            displayType={'text'} 
                            thousandSeparator={true} 
                            prefix={'$'}/></div>
            {t('FUM:slksFum')}</Link></div>
        
        <div><Link className="adviserLoginDataLink link" to="/adv/totalMembers/SLI">
            <div className="adviserDataSplit"><CurrencyFormat  value={Number(totalFumDetails.invest).toFixed(2)} 
                            displayType={'text'} 
                            thousandSeparator={true} 
                            prefix={'$'}/></div>
            {t('FUM:sliFum')}</Link></div>
        
        <div><Link className="adviserLoginDataLink link" to="/adv/totalMembers/SLKS">
            <div className="adviserDataSplit"><CurrencyFormat  value={Number(totalFumDetails.kiwiSaver).toFixed(2)} 
                            displayType={'text'} 
                            thousandSeparator={true} 
                            prefix={'$'}/></div>
            {t('FUM:slukFum')}</Link></div> */}
    </div>
        
        // <div style={{marginLeft: "auto", marginRight: "auto", paddingTop: "10px"}}>
        //     <table className="adviserLogin">
        //         <tr>
        //             <th><Link className="adviserLoginLink link" to="/adv/totalMembers">{t('totalFum')} </Link></th>
        //             <td style={{color: "white", fontSize: "16px"}}>
        //                 <CurrencyFormat  value={Number(totalFumDetails.totalFum).toFixed(2)} 
        //                     displayType={'text'} 
        //                     thousandSeparator={true} 
        //                     prefix={'$'}/>
        //             </td>
        //         </tr>
        //     </table>
        //     <table className="adviserLogin adviserLoginData">
        //         <tr>
        //             <th><Link className="adviserLoginDateLink link" to="/adv/totalMembers/SLKS">{t('kiwiSaver')}</Link></th>
        //             <td style={{color: "#333333", fontSize: "16px"}}>
        //                 <CurrencyFormat  value={Number(totalFumDetails.kiwiSaver).toFixed(2)} 
        //                     displayType={'text'} 
        //                     thousandSeparator={true} 
        //                     prefix={'$'}/></td>
        //         </tr>
        //         <tr>
        //             <th><Link className="adviserLoginDateLink link" to="/adv/totalMembers/SLI">{t('invest')}</Link></th>
        //             <td style={{color: "#333333", fontSize: "16px"}}>
        //                 <CurrencyFormat  value={Number(totalFumDetails.invest).toFixed(2)} 
        //                     displayType={'text'} 
        //                     thousandSeparator={true} 
        //                     prefix={'$'}/></td>
        //         </tr>
        //         <tr>
        //             <th><Link className="adviserLoginDateLink link" to="/adv/totalMembers/SLUK">{t('ukPension')}</Link></th>
        //             <td style={{color: "#333333", fontSize: "16px"}}>
        //                 <CurrencyFormat  value={Number(totalFumDetails.ukPension).toFixed(2)}
        //                     displayType={'text'} 
        //                     thousandSeparator={true} 
        //                     prefix={'$'}/></td>
        //         </tr>
        //     </table>
        // </div>
    )
}

export default withTranslation()(TotalFum);